import { AplicacaoRotas } from "../models/aplicacao-rotas.model";

export const APLICACAO_ROTAS_PARCERIAS: AplicacaoRotas = {
   dadosPessoais: {
      statusProposta: 17,
      rota: "/abertura-conta/tradicional/proponentes/dados-pessoais",
      statusPreenchimento: false
   },
   dadosComplementares: {
      statusProposta: 17,
      rota: "/abertura-conta/tradicional/proponentes/dados-complementares",
      statusPreenchimento: false
   },
   documentosProponentesUpload: {
      statusProposta: 19,
      rota: "/abertura-conta/tradicional/documentos/documentos-proponentes/upload",
      statusPreenchimento: false
   },
   documentosProponentesUploadPendente: {
      statusProposta: 19,
      rota: "/abertura-conta/tradicional/documentos/documentos-proponentes/upload-pendente",
      statusPreenchimento: false
   },
   assinaturaDigitalParcerias: {
      statusProposta: 19,
      rota: "/abertura-conta/tradicional/assinatura/assinatura-digital-parcerias",
      statusPreenchimento: false
   },
   feedback: {
      statusProposta: 21,
      rota: "/abertura-conta/feedback",
      statusPreenchimento: false
   },
   listaPropostas: {
      statusProposta: 29,
      rota: "/abertura-conta/propostas",
      statusPreenchimento: true
   },
   statusEncerrada: {
      statusProposta: 0,
      rota: "/abertura-conta/status/proposta-encerrada",
      statusPreenchimento: true
   },
   statusFinalizada: {
      statusProposta: 0,
      rota: "/abertura-conta/status/proposta-finalizada",
      statusPreenchimento: true
   },
   statusAnalise: {
      statusProposta: 0,
      rota: "/abertura-conta/status/proposta-analise",
      statusPreenchimento: true
   },
   statusCancelada: {
      statusProposta: 17,
      rota: "/abertura-conta/status/proposta-cancelada",
      statusPreenchimento: false
   },
   error: {
      statusProposta: 17,
      rota: "/abertura-conta/error",
      statusPreenchimento: false
   },
};